import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import globalStyles from "../../../Styles/global.module.scss"
import styles from "../../../Styles/ComponentStyles/MainPages/Member.module.scss"

import moment from 'moment';
import Grid from '@mui/material/Grid2';
import { Avatar, CircularProgress, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import editIcon from "../../../Assets/Member/Edit-Icon.svg"
import deleteIcon from "../../../Assets/Member/Delete-Icons.svg"
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';


import GlobalTextfield from '../../../Utils/Layout/GlobalTextfield/GlobalTextfield';
import GlobalSelect from '../../../Utils/Layout/GlobalSelect/GlobalSelect';
import GlobalButton from '../../../Utils/Layout/GlobalButton/GlobalButton';
import useStateOptions from '../../../Utils/Hooks/useStateOptions';

import { useIsBelow900 } from '../../../Utils/Constant/Constant';
import { useSnackbar } from '../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';

import { GroupNameResponseModel, UpdateMemberDetailsPayload } from '../../../models/memberAxiosModels';
import { MemberContext, MemberContextPayload } from '../../../Context/MemberDetailsContext';
import { GlobalUserContext, GlobalUserContextPayload } from '../../../Context/GlobalUserDetailContext';

import agent from '../../../Services/api';
import GlobalTabs from '../../../Utils/Layout/GlobalTabs/GlobalTabs';
import { RemoveProfileCredPayload } from '../../../models/userDetailsModel';
import GlobalDialog from '../../../Utils/Layout/GlobalDialog/GlobalDialog';
import GlobalWarningDialog from '../../../Utils/Layout/GlobalWarningDialog/GlobalWarningDialog';
import GlobalSymbols from '../../../Utils/Layout/GlobalSymbols/GlobalSymbols';

const ViewUsers = () => {

    const navigate = useNavigate()
    const isBelow900 = useIsBelow900();
    const { showSnackbar } = useSnackbar();
    const { stateOptions, getStateOptions } = useStateOptions();

    const {
        storedExistingMemberDetails,
        setStoredExistingMemberDetails,
        userCredentialListDetails,
        setUserCredentialListDetails,

        setUserGroupListDetails,
        userGroupListDetails
    } = useContext(MemberContext) as MemberContextPayload

    const { setFlagLoader } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const [searchParams, setSearchParams] = useSearchParams();
    const userId = parseInt(searchParams.get('userId') || '', 10);
    const tabFromURL = searchParams.get("tab") || "1";
    const userTabs = [
        { label: 'Profile', value: '1' },
        { label: 'Integration', value: '2' },
    ];

    const imageInputRef = useRef<HTMLInputElement>(null);
    const [userStatusList, setUserStatusList] = useState<GroupNameResponseModel | null>(null)
    const [uploadFileId, setUploadFileId] = useState<number | null>(null)
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [currentTab, setCurrentTab] = useState(tabFromURL);
    const [isCredentialEditable, setIsCredentialEditable] = useState(false);
    const [originalCredentialDetails, setOriginalCredentialDetails] = useState<any | null>(null);
    // const [userGroupList, setUserGroupList] = useState<AppStatusResponse | null>(null)
    const [flagDeleteDialog, setFlagDeleteDialog] = useState<any | null>(false);
    const isChanged = (
        userCredentialListDetails?.username !== originalCredentialDetails?.username ||
        userCredentialListDetails?.password !== originalCredentialDetails?.password
    );
    const isDisabled = isCredentialEditable ? (!userCredentialListDetails?.username || !userCredentialListDetails?.password) : false;
    const userSaveValidation = !userCredentialListDetails?.username || !userCredentialListDetails?.password
    const isDisabledSave = !storedExistingMemberDetails?.firstName?.trim() ||
        !storedExistingMemberDetails?.lastName?.trim() ||
        !storedExistingMemberDetails?.agencyName?.trim() ||
        !storedExistingMemberDetails?.contact?.trim() ||
        !storedExistingMemberDetails?.stateID;


    const initializeCredentialAuth = async () => {
        let payload = {
            userId: Number(userId)
        }
        setFlagLoader(true);
        const response = await agent.getUsersCredentialsApi.get(payload);

        if (response?.status && response?.data) {
            const userResponse = response.data?.credentials[0]
            setUserCredentialListDetails(userResponse);
            setOriginalCredentialDetails(userResponse);
            setFlagLoader(false);
        }
        else {
            setFlagLoader(false);
            const errorMessage = response?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
        }
    };

    const fetchUserGroupData = async () => {
        setFlagLoader(true)
        const response = await agent.getGroupDetailsByGroupApi.get()
        if (response?.status) {
            console.log("response of getUserGroupsApi", response);
            const responseData = response?.data
            setUserGroupListDetails(responseData)
            setFlagLoader(false)
        }
        else {
            const errorMessage = response?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
            setFlagLoader(false);
        }
    }

    useEffect(() => {
        const tabFromURL = searchParams.get("tab") || "1";
        setCurrentTab(tabFromURL);
    }, [searchParams]);

    useEffect(() => {
        if (userId) {
            const fetchUserData = async () => {
                const payload = {
                    searchString: null,
                    userId: String(userId)
                }

                const response = await agent.getUsersByParamsApi.get(payload);
                if (response?.status && response?.data) {
                    console.log("response of getUsersByParamsApi", response);
                    const responseData = response?.data?.users[0]
                    setStoredExistingMemberDetails(responseData)

                }
                else {
                    // handle non-successful response
                }
            };
            fetchUserData();
            fetchUserGroupData();
        }
    }, [userId]);

    useEffect(() => {
        const initializeAll = async () => {
            setFlagLoader(true);

            // Fetch user status list
            try {
                const response = await agent.getUsersStatusApi.get();
                if (response?.status && response?.data?.userStatus) {
                    const filteredStatuses = response?.data?.userStatus?.filter((status: any) =>
                        status.user_status_desc?.toLowerCase() !== "deleted" &&
                        status.user_status_desc?.toLowerCase() !== "underreview"
                    );
                    setUserStatusList({ ...response.data, userStatus: filteredStatuses });
                } else {
                    setUserStatusList(null);
                    const message = response?.message || "Something Went Wrong!";
                    showSnackbar(message, "error");
                }
            }
            catch (error) {
                setUserStatusList(null);
                showSnackbar("Failed to fetch user statuses", "error");
            }

            // Fetch state options
            getStateOptions();

            // If editing a user
            if (userId) {
                initializeCredentialAuth();
            }

            setFlagLoader(false);
        };

        initializeAll();
    }, []);


    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setCurrentTab(newValue);
        setSearchParams(prev => {
            const params = new URLSearchParams(prev);
            params.set('tab', newValue);
            return params;
        });
    };

    const handleUpdateProfileDetails = async () => {

        const payload: UpdateMemberDetailsPayload = {
            userId: storedExistingMemberDetails?.userId ?? 0,
            firstName: storedExistingMemberDetails?.firstName ?? "",
            lastName: storedExistingMemberDetails?.lastName ?? "",
            status: storedExistingMemberDetails?.userStatus?.status ?? "",
            contact: storedExistingMemberDetails?.contact ?? "",
            agencyName: storedExistingMemberDetails?.agencyName ?? "",
            city: storedExistingMemberDetails?.city ?? "",
            zipcode: storedExistingMemberDetails?.zipcode ?? "",
            stateID: storedExistingMemberDetails?.stateID ?? 0,
            addressLine1: storedExistingMemberDetails?.addressLine1 ?? "",
            addressLine2: storedExistingMemberDetails?.addressLine2 ?? "",
            affiliated_Brooklight: storedExistingMemberDetails?.affiliated_Brooklight ?? false,
            affiliated_BA: storedExistingMemberDetails?.affiliated_BA ?? false,
            profileImage: uploadFileId ?? 0,
            groupId: storedExistingMemberDetails?.group?.id
        };

        setFlagLoader(true)
        const response = await agent.updateUserStatusApi.put(payload)
        if (response?.status) {
            console.log("response of updateUserStatusApi", response);
            const successMessage = response?.message ? response?.message : "User details updated successfully!"
            showSnackbar(successMessage, "success");
            setFlagLoader(false)
        }
        else {
            console.log("response false of updateUserStatusApi", response);
            const successMessage = response?.error?.message ? response?.error?.message : "Something Went Wrong!"
            showSnackbar(successMessage, "error");
            setFlagLoader(false)
        }
    }

    const handleProfileMenuClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (imageInputRef.current) {
            imageInputRef.current.click(); // ← triggers file picker
        }
    };

    const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setIsUploading(true);
        const formData = new FormData();
        formData.append("file", file);

        const response = await agent.uploadResourceFileAPI.post(formData)
        if (response?.status) {
            console.log("uploadResourceFileAPI response", response);
            const responseData = response?.data
            setIsUploading(false);
            setUploadFileId(responseData.google_storage_id)
            setStoredExistingMemberDetails({
                ...storedExistingMemberDetails,
                profileImage: responseData.google_storage_public_url
            })
        }
        else {
            console.error("Upload failed:", response);
            setIsUploading(false);
        }

        e.target.value = ""
    }

    const handleInputChange = (key: keyof typeof storedExistingMemberDetails, value: any) => {
        setStoredExistingMemberDetails((prev: any) => ({
            ...prev,
            [key]: value
        }));
    };

    const handleCredentialChange = (key: string, value: string) => {
        setUserCredentialListDetails((prev: any) => ({
            ...prev,
            [key]: value
        }));
    };

    const handleUpdateCredentials = async () => {

        const payload = {
            userId: storedExistingMemberDetails?.userId ?? 0,
            appName: userCredentialListDetails?.appName ?? "",
            username: userCredentialListDetails?.username ?? "",
            password: userCredentialListDetails?.password ?? ""
        }

        setFlagLoader(true)
        const response = await agent.changeUserCredentialsApi.post(payload)
        if (response?.status) {
            console.log("response of updateUserStatusApi", response);
            const successMessage = response?.message ? response?.message : "User credentials updated successfully!"
            showSnackbar(successMessage, "success");
            setFlagLoader(false)
            setIsCredentialEditable(false)
        }
        else {
            console.log("response false of updateUserStatusApi", response);
            setFlagLoader(false)
            const error = response?.error?.message
            if (error == "Invalid Login Attempt (Incorrect Username and/or Password)") {
                showSnackbar(
                    <div><strong>Redtail!</strong>
                        <br />
                        Invalid credentials. Account may be locked after multiple failed attempts.
                    </div>,
                    'error'
                );
            }
            else {
                showSnackbar(
                    <div><strong>Redtail!</strong>
                        <br />
                        {error}
                    </div>,
                    'error'
                );
            }
            // const successMessage = response?.error?.message ? response?.error?.message : "Something Went Wrong!"
            // showSnackbar(successMessage, "error");
            // setFlagLoader(false)
        }
    }

    const handleDeleteCred = async () => {

        const payload: RemoveProfileCredPayload = {
            userId: Number(userId),
            appName: userCredentialListDetails?.appName ?? ""
        }

        setFlagLoader(true)
        const response = await agent.deleteUserProfileCredentials.post(payload)
        console.log("Response log deleteUserProfileCredentials", response);
        if (response?.status) {
            const successMessage = response?.message ? response?.message : `Credential for ${userCredentialListDetails?.appName ?? ""} removed successfully!`
            showSnackbar(successMessage, "success");
            await initializeCredentialAuth()
            setFlagLoader(false)
            setIsCredentialEditable(false)
            setFlagDeleteDialog(false)
        }
        else {
            const successMessage = response?.error?.message ? response?.error?.message : "Something Went Wrong!"
            showSnackbar(successMessage, "error");
            setFlagLoader(false)
            setFlagDeleteDialog(false)
        }
    }

    // useEffect(() => {
    //     const fetchGroups = async () => {
    //         const response = await agent.getUsersStatusApi.get();
    //         if (response?.status && response?.data && response?.data?.userStatus) {
    //             setUserStatusList(response?.data)
    //         }
    //         else {
    //             setUserStatusList(null)
    //             const successMessage = response?.message ? response?.message : "Something Went Wrong!"
    //             showSnackbar(successMessage, "error");
    //             setFlagLoader(false)
    //         }
    //     };

    //     fetchGroups();
    // }, [])

    // useEffect(() => {
    //     getStateOptions()
    // }, [])

    // useEffect(() => {
    //     if (userId) {
    //         initializeCredentialAuth()
    //     }
    // }, [])

    const handleRollbackClick = () => {
        if (originalCredentialDetails) {
            setUserCredentialListDetails({ ...originalCredentialDetails });
        }
        setIsCredentialEditable(false);
    };

    const handleEditClick = () => {
        setOriginalCredentialDetails({ ...userCredentialListDetails });
        setUserCredentialListDetails((prev: any) => ({
            ...prev,
            password: ''
        }));
        setIsCredentialEditable(true);
    };


    return (
        <>
            {flagDeleteDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    open={flagDeleteDialog}
                    maxWidth="sm"
                    dialogHead={'Delete Confirmation'}
                    onClose={() => setFlagDeleteDialog(false)}
                    view={
                        <GlobalWarningDialog
                            popupDescription={`Are you sure you want to delete ${userCredentialListDetails?.username}?`}
                            primaryButtonText={"Delete"}
                            secondaryButtonText={"Cancel"}
                            primaryButtonWidth="175px"
                            secondaryButtonWidth="175px"
                            onDelete={handleDeleteCred}
                            handleClose={() => setFlagDeleteDialog(false)}
                        />
                    }
                />
            }

            <Grid container>
                <Grid size={{ xs: 12 }} className={`${styles.viewUserMainItem}`}>
                    <Grid container>
                        <Grid size={{ xs: 12 }} sx={{ marginBottom: "20px" }}>
                            <Grid container sx={{ justifyContent: "space-between" }}>
                                <Grid className={styles.userSaveCancelBtnItem}>
                                    <GlobalButton
                                        fullWidth={true}
                                        value='Back'
                                        variant='text'
                                        className={globalStyles.globalButtonTextStyleV1}
                                        size='medium'
                                        startIcon={<ArrowBackIcon sx={{ color: 'white' }} />}
                                        onClick={() => { navigate('/member') }}
                                    />
                                </Grid>
                                {/* <Grid className={styles.userSaveCancelBtnItem}>
                                    <GlobalButton
                                        fullWidth={true}
                                        value='Save'
                                        variant='contained'
                                        className={!storedExistingMemberDetails?.firstName || !storedExistingMemberDetails?.lastName ? globalStyles.globalButtonContainedStyleDisabledV1 : globalStyles.globalButtonContainedStyleV1}
                                        size='medium'
                                        onClick={() => { handleUpdateProfileDetails() }}
                                        disabled={!storedExistingMemberDetails?.firstName || !storedExistingMemberDetails?.lastName ? true : false}
                                    />
                                </Grid> */}
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Grid container className={styles.viewUserSaveCancelBtnItem}>
                                <Grid className={styles.memberUserProfileItem}>
                                    <Grid container className={styles.memberUserProfileContainer}>
                                        <Grid className={styles.memberProfileImageItem} sx={{ height: "100%" }}>
                                            <Avatar
                                                src={storedExistingMemberDetails?.profileImage || ""}
                                                sx={{ width: "100%", height: "100%" }}
                                            />
                                            {isUploading && (
                                                <div style={{ position: "absolute", zIndex: 2, top: "30px", left: "30px" }}>
                                                    <CircularProgress />
                                                </div>
                                            )}
                                            <div
                                                className={styles.memberProfileEditImageItem}
                                                onClick={handleProfileMenuClick}
                                            >
                                                <EditIcon
                                                    sx={{
                                                        background: '#0280FA',
                                                        color: 'white',
                                                        verticalAlign: "middle",
                                                        fontSize: '15px',
                                                        marginBottom: '2px',
                                                        borderRadius: "50%",
                                                        padding: "5px"
                                                    }}
                                                />
                                            </div>
                                            <input
                                                type="file"
                                                id="avatar"
                                                accept="image/*"
                                                ref={imageInputRef}
                                                style={{ display: "none" }}
                                                onChange={handleImageUpload}
                                            />
                                        </Grid>

                                        <Grid className={styles.memberProfileDetailsItem}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV20}`} sx={{ textTransform: "capitalize" }}>
                                                        {storedExistingMemberDetails?.firstName ? storedExistingMemberDetails?.firstName : "" + " " + storedExistingMemberDetails?.lastName ? storedExistingMemberDetails?.lastName : ""}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`} sx={{ fontWeight: '300 !important' }}>
                                                        {storedExistingMemberDetails?.email ? storedExistingMemberDetails?.email : ""}
                                                    </Typography>
                                                </Grid>
                                                <Grid sx={{ maxWidth: '170px', marginTop: "10px" }}>
                                                    <Typography component={'span'} className={`${globalStyles.gblC7C7C7} ${globalStyles.globalTextV13}`}>
                                                        Created At: {storedExistingMemberDetails?.createdAt ? moment(storedExistingMemberDetails?.createdAt)?.format("MM/DD/YYYY") : ""}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ margin: "25px 0px" }}>
                            <Grid container>

                                <Grid size={{ xs: 12 }} sx={{ margin: "0px 0px 15px" }}>
                                    <GlobalTabs
                                        tabs={userTabs}
                                        currentTab={currentTab}
                                        onChange={(event: React.SyntheticEvent, newValue: string) => handleTabChange(event, newValue)}
                                        sxTabStyle={{
                                            textTransform: 'none',
                                            color: '#7E7E7E',
                                            marginRight: '20px',
                                            fontWeight: 'normal',
                                            fontSize: '1rem',
                                            '&.Mui-selected': {
                                                color: '#ffffff',
                                                fontWeight: 'bold',
                                            }
                                        }}
                                    />
                                </Grid>

                                {currentTab == "1" &&
                                    <Grid size={{ xs: 12 }} sx={{ margin: "15px 0px 0px" }}>
                                        <Grid container sx={{ rowGap: "30px" }}>

                                            <Grid size={{ xs: 12 }}>
                                                <Grid container sx={{ gap: "20px" }}>
                                                    <Grid size={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 12 }} sx={{ maxWidth: "300px" }}>
                                                        <Grid container>
                                                            <Grid size={{ xs: 12 }} sx={{ marginBottom: '10px' }}>
                                                                <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>User Status</Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }} >
                                                                <GlobalSelect
                                                                    size='small'
                                                                    fullWidth
                                                                    className={`${globalStyles.gblDropdownStyles}`}
                                                                    value={storedExistingMemberDetails?.userStatus?.id || ""}
                                                                    options={
                                                                        userStatusList?.userStatus?.length
                                                                            ? userStatusList.userStatus.map((status: any) => ({
                                                                                label: status.user_status_desc,
                                                                                value: status.user_status_id
                                                                            }))
                                                                            : []
                                                                    }
                                                                    onChange={(e) => {
                                                                        const selectedId = Number(e.target.value);
                                                                        const matched = userStatusList?.userStatus.find(
                                                                            (status) => status.user_status_id === selectedId
                                                                        );
                                                                        if (matched) {
                                                                            handleInputChange("userStatus", {
                                                                                id: matched.user_status_id,
                                                                                status: matched.user_status_desc
                                                                            });
                                                                        }
                                                                    }}
                                                                // onChange={(e) => handleInputChange("user_status_id", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid size={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 12 }} sx={{ maxWidth: "300px" }}>
                                                        <Grid container>
                                                            <Grid size={{ xs: 12 }} sx={{ marginBottom: '10px' }}>
                                                                <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>User Group</Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }} >
                                                                <GlobalSelect
                                                                    size='small'
                                                                    fullWidth
                                                                    className={`${globalStyles.gblDropdownStyles}`}
                                                                    value={
                                                                        storedExistingMemberDetails?.group?.id && userGroupListDetails?.groups?.length ? String(storedExistingMemberDetails.group.id) : ''
                                                                    }
                                                                    options={
                                                                        userGroupListDetails?.groups?.length ? userGroupListDetails.groups.map((group: any) => ({ label: group.groupName, value: String(group.groupId) })) : []
                                                                    }
                                                                    onChange={(e) => {
                                                                        const groupID = Number(e.target.value)
                                                                        const groupName = userGroupListDetails?.groups?.find((ele) => ele?.groupId == groupID)?.groupName
                                                                        setStoredExistingMemberDetails({
                                                                            ...storedExistingMemberDetails,
                                                                            group: {
                                                                                ...storedExistingMemberDetails.group,
                                                                                id: groupID,
                                                                                name: groupName
                                                                            }

                                                                        })
                                                                    }}
                                                                    renderValue={(value) => {
                                                                        if (!value || !userGroupListDetails?.groups?.length) return '';

                                                                        const selected = userGroupListDetails.groups.find((g) => g.groupId === Number(value));
                                                                        return selected ? selected.groupName : '';
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>


                                            <Grid size={{ xs: 12 }}>
                                                <Grid container sx={{ columnGap: '40px', rowGap: '30px' }}>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    User Name
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth={true}
                                                                    size='small'
                                                                    disabled={true}
                                                                    autoComplete='off'
                                                                    placeholder='Enter Username'
                                                                    value={storedExistingMemberDetails?.username ? storedExistingMemberDetails?.username : ""}
                                                                    onChange={(e) => handleInputChange("username", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    First Name <GlobalSymbols symbol={"astric"} />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter First Name'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.firstName ? storedExistingMemberDetails?.firstName : ""}
                                                                    onChange={(e) => handleInputChange("firstName", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Last Name <GlobalSymbols symbol={"astric"} />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Last Name'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.lastName ? storedExistingMemberDetails?.lastName : ""}
                                                                    onChange={(e) => handleInputChange("lastName", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Agency Name <GlobalSymbols symbol={"astric"} />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Agency Name'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.agencyName ? storedExistingMemberDetails?.agencyName : ""}
                                                                    onChange={(e) => handleInputChange("agencyName", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Phone <GlobalSymbols symbol={"astric"} />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Phone Number'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.contact ? storedExistingMemberDetails?.contact : ""}
                                                                    onChange={(e) => handleInputChange("contact", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    City
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter City'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.city ? storedExistingMemberDetails?.city : ""}
                                                                    onChange={(e) => handleInputChange("city", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Zipcode
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Zip Code'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.zipcode ? storedExistingMemberDetails?.zipcode : ""}
                                                                    onChange={(e) => handleInputChange("zipcode", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    State <GlobalSymbols symbol={"astric"} />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }} >
                                                                <GlobalSelect
                                                                    size='small'
                                                                    fullWidth
                                                                    className={`${globalStyles.gblDropdownStyles}`}
                                                                    options={
                                                                        stateOptions?.length ? stateOptions.map(state => ({
                                                                            label: `${state.state_name} (${state.state_abb})`,
                                                                            value: state.state_id
                                                                        })) : []
                                                                    }
                                                                    MenuProps={{ className: styles.userStateSelect }}
                                                                    onChange={(e) => handleInputChange("stateID", e.target.value)}
                                                                    value={storedExistingMemberDetails?.stateID || ""}
                                                                    renderValue={(selected) => {
                                                                        const selectedState = stateOptions.find(s => s.state_id == selected);
                                                                        return selectedState ? `${selectedState.state_name} (${selectedState.state_abb})` : '';
                                                                    }}

                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Address Line 1
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }} >
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Address'
                                                                    autoComplete='off'
                                                                    multiline
                                                                    rows={3}
                                                                    stylingClassName={styles.memberProfileMultilineField}
                                                                    value={storedExistingMemberDetails?.addressLine1 ? storedExistingMemberDetails?.addressLine1 : ""}
                                                                    onChange={(e) => handleInputChange("addressLine1", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Address Line 2
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }} >
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Address'
                                                                    autoComplete='off'
                                                                    multiline
                                                                    rows={3}
                                                                    stylingClassName={styles.memberProfileMultilineField}
                                                                    value={storedExistingMemberDetails?.addressLine2 ? storedExistingMemberDetails?.addressLine2 : ""}
                                                                    onChange={(e) => handleInputChange("addressLine2", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    {/* <Grid className={`${styles.memberuserFieldItem}`}>
                                    <Grid container sx={{ rowGap: { lg: "5px", md: "0px" } }}>
                                        <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                            <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                Affiliated with Broker Alliance
                                            </Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={true}
                                                        icon={<Icons iconName="checkbox" iconWidth="20px" iconHeight="20px" />}
                                                        checkedIcon={<Icons iconName="checkedIcon" iconWidth="20px" iconHeight="20px" />}
                                                        sx={{ padding: "0px 8px" }}
                                                    />
                                                }
                                                label=""
                                                className={styles.signinCheckboxLabel}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid className={`${styles.memberuserFieldItem}`}>
                                    <Grid container sx={{ rowGap: { lg: "5px", md: "0px" } }}>
                                        <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                            <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                Affiliated with Brooklight Place Securities
                                            </Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={true}
                                                        icon={<Icons iconName="checkbox" iconWidth="20px" iconHeight="20px" />}
                                                        checkedIcon={<Icons iconName="checkedIcon" iconWidth="20px" iconHeight="20px" />}
                                                        sx={{ padding: "0px 8px" }}
                                                    />
                                                }
                                                label=""
                                                className={styles.signinCheckboxLabel}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {currentTab == "2" &&
                                    <Grid size={{ xl: 7, lg: 9.5, md: 12, sm: 12, xs: 12 }} sx={{ margin: "15px 0px 0px" }}>
                                        <Grid container>

                                            <TableContainer>
                                                <Table size='small'>
                                                    <TableHead className={`${globalStyles.gblTableHeadStyles}`}>
                                                        <TableRow>
                                                            <TableCell
                                                                className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableMediumWidth}`}
                                                                sx={{ fontSize: "14px", borderTopLeftRadius: "5px" }}
                                                            >
                                                                APPS
                                                            </TableCell>
                                                            <TableCell
                                                                className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableMediumWidth}`}
                                                                sx={{ fontSize: "14px" }}
                                                            >
                                                                USER NAME
                                                            </TableCell>
                                                            <TableCell
                                                                className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableMediumWidth}`}
                                                                sx={{ fontSize: "14px", }}
                                                            >
                                                                USER PASSWORD
                                                            </TableCell>
                                                            <TableCell
                                                                className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableExtraSmallWidth}`}
                                                                sx={{ fontSize: "14px", borderTopRightRadius: "5px" }}
                                                            >
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow className={`${globalStyles.gblTableBodyRow}`}>
                                                            <TableCell className={`${globalStyles.gblTableCellText}`}>
                                                                {userCredentialListDetails?.appName ? userCredentialListDetails?.appName : ""}
                                                            </TableCell>

                                                            <TableCell className={`${globalStyles.gblTableCellText}`}>
                                                                <GlobalTextfield
                                                                    size='small'
                                                                    stylingClassName={isCredentialEditable ? styles.credTextfield : styles.credTextfieldDisable}
                                                                    autoComplete='off'
                                                                    value={userCredentialListDetails?.username || ""}
                                                                    onChange={(e) => handleCredentialChange("username", e.target.value)}
                                                                    disabled={isCredentialEditable ? false : true}
                                                                />
                                                            </TableCell>

                                                            <TableCell className={`${globalStyles.gblTableCellText}`}>
                                                                <GlobalTextfield
                                                                    size='small'
                                                                    stylingClassName={isCredentialEditable ? styles.credTextfield : styles.credTextfieldDisable}
                                                                    autoComplete='off'
                                                                    type='password'
                                                                    value={userCredentialListDetails?.password || ""}
                                                                    onChange={(e) => handleCredentialChange("password", e.target.value)}
                                                                    disabled={isCredentialEditable ? false : true}
                                                                />
                                                            </TableCell>

                                                            <TableCell className={`${globalStyles.gblTableCellText}  ${globalStyles.gblTableMediumWidth}`}>
                                                                <Grid container sx={{ justifyContent: "end", gap: "5px", alignItems: "center" }}>
                                                                    {isChanged && (
                                                                        <IconButton
                                                                            className={styles.rollbackCellIcon}
                                                                            onClick={() => { handleRollbackClick() }}
                                                                        >
                                                                            <Tooltip
                                                                                title="Undo"
                                                                                arrow
                                                                                placement="bottom"
                                                                                componentsProps={{
                                                                                    tooltip: { className: globalStyles.globalTooltipStyle },
                                                                                    arrow: { className: globalStyles.globalTooltipArrowStyle },
                                                                                }}
                                                                            >
                                                                                <SettingsBackupRestoreIcon sx={{ color: "white", cursor: "pointer !important", fontSize: "22px" }} />
                                                                            </Tooltip>
                                                                        </IconButton>
                                                                    )}
                                                                    <IconButton
                                                                        className={`${isDisabled ? globalStyles.disableBtnPointerEvent : ''}`}
                                                                        onClick={isCredentialEditable ? handleUpdateCredentials : handleEditClick}
                                                                        disabled={isDisabled}
                                                                        sx={{ p: "2px", }}
                                                                    // onClick={() => { setIsCredentialEditable(true) }}
                                                                    >
                                                                        {isCredentialEditable ? (
                                                                            <Tooltip
                                                                                title="Save"
                                                                                arrow
                                                                                placement="bottom"
                                                                                componentsProps={{
                                                                                    tooltip: { className: globalStyles.globalTooltipStyle },
                                                                                    arrow: { className: globalStyles.globalTooltipArrowStyle },
                                                                                }}
                                                                            >
                                                                                <SaveIcon className={styles.rightMarkIcon} sx={{ color: "white", fontSize: "22px" }} />
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <Tooltip
                                                                                title="Edit"
                                                                                arrow
                                                                                placement="bottom"
                                                                                componentsProps={{
                                                                                    tooltip: { className: globalStyles.globalTooltipStyle },
                                                                                    arrow: { className: globalStyles.globalTooltipArrowStyle },
                                                                                }}
                                                                            >
                                                                                <EditIcon className={styles.editMarkIcon} sx={{ color: "white", fontSize: "22px" }} />
                                                                            </Tooltip>
                                                                        )}
                                                                    </IconButton>
                                                                    <IconButton
                                                                        sx={{ p: "2px" }}
                                                                        disabled={userSaveValidation ? true : false}
                                                                        className={`${userSaveValidation ? globalStyles.disableBtnPointerEvent : ''}`}
                                                                        onClick={() => { setFlagDeleteDialog(true) }}
                                                                    >
                                                                        <Tooltip
                                                                            title="Delete"
                                                                            arrow
                                                                            placement="bottom"
                                                                            componentsProps={{
                                                                                tooltip: { className: globalStyles.globalTooltipStyle },
                                                                                arrow: { className: globalStyles.globalTooltipArrowStyle },
                                                                            }}
                                                                        >
                                                                            <img src={deleteIcon} style={{ width: '30px', height: "30px" }} alt="delete" />
                                                                        </Tooltip>
                                                                    </IconButton>
                                                                </Grid>

                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                        </Grid>
                                    </Grid>
                                }

                                <Grid size={{ xs: 12 }} sx={{ margin: "25px 0px 0px" }}>
                                    <Grid container sx={{ alignItems: 'center', gap: "20px" }}>
                                        {currentTab === "1" && (
                                            <Grid className={styles.atUserProfileBtnItem}>
                                                <GlobalButton
                                                    value='Cancel'
                                                    size='medium'
                                                    fullWidth={true}
                                                    variant='outlined'
                                                    className={globalStyles.globalButtonOutlinedStyleV1}
                                                    onClick={() => { navigate('/member') }}
                                                />
                                            </Grid>
                                        )}
                                        <Grid className={styles.atUserProfileBtnItem}>
                                            {currentTab === "1" && (
                                                <GlobalButton
                                                    value='Save'
                                                    size='medium'
                                                    fullWidth
                                                    variant='contained'
                                                    className={globalStyles.globleButtonStyleV1}
                                                    disabled={isDisabledSave}
                                                    onClick={handleUpdateProfileDetails}
                                                    sx={{ background: (isDisabledSave) ? "gray !important" : "white !important" }}
                                                />
                                            )}

                                            {/* {currentTab === "2" && (
                                                <GlobalButton
                                                    value='Save'
                                                    size='medium'
                                                    fullWidth
                                                    variant='contained'
                                                    className={`${globalStyles.globleButtonStyleV1}`}
                                                    disabled={!userCredentialListDetails?.username || !userCredentialListDetails?.password}
                                                    onClick={handleUpdateCredentials}
                                                    sx={{ background: (!userCredentialListDetails?.username || !userCredentialListDetails?.password) ? "gray !important" : "white !important" }}
                                                />
                                            )} */}
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </>
    )
}

export default ViewUsers